import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class MpjobService {

  constructor(private http: HttpClient) { }

  addJob(data: any): Observable<any> {
    console.log('Adding Jobs', data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "mpjobs", data).subscribe((res: any) => {
        observer.next(res.data);
        observer.complete();
      }, err => {
        console.log("ERROR");
        observer.error(err.msg);
      }, () => {
        observer.complete()
      })
    })
  }

  editJob(data: any, jobId): Observable<any> {
    console.log('Adding Jobs', data, jobId);

    Object.assign(data, { _id: jobId })

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "mpjobs", data).subscribe((res: any) => {
        console.log("response of edit mp job", res);

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR");
        observer.error(err.msg);
      }, () => {
        observer.complete()
      })
    })
  }



  deleteJobs(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "mpjobs?_id=" + id).subscribe((res: any) => {
        observer.next(res.data.jobs);
        observer.complete();
      })
    })
  }


  getJobById(jobId): Observable<any> {
    console.log("Getting jobs", jobId);
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs?jobType=mp&_id=" + jobId).subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  getAllCandidateList(jobId) {
    console.log("Getting jobs", jobId);
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "mpjobs/candidate-list?_id=" + jobId).subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  getCandidateMedicalStatus(jobId) {
    console.log("Getting jobs", jobId);
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "mpjobs//medical-status?_id=" + jobId).subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  downloadStatusOfCandidate(jobId) {
    console.log("Getting jobs", jobId);
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "mpjobs/medical-status-report?_id=" + jobId).subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res.data);
        observer.complete();
      }, err => {
        observer.error(err.msg)
        observer.complete();
      })
    });
  }

}
